import { login, getDemoPassword, getAuthToken, isSigningIn, SIGN_IN_TIMEOUT_MS } from '@/api/persist';
import { selfPersonIdFromSession } from '@/utils/commsHelpers';
import { useSessionStore } from '@/state/sessionStore';
import { useUIStore } from '@/state/uiStore';
import type { PersonaCardSpec } from '@/data/personas';

/**
 * Sign in as a persona card (B3). The token names the persona AND the person
 * behind it, the same id the audit rows record (currentActorId), so the server
 * can check who decides a no-deposit override or approves a recon line.
 */
export function signInAsCard(card: PersonaCardSpec): Promise<boolean> {
  const pid =
    selfPersonIdFromSession({
      persona: card.persona,
      agentId: card.agentId ?? null,
      artistId: card.artistId ?? null,
      apprenticeId: card.apprenticeId ?? null,
    }) ?? card.persona;
  return login(card.persona, card.activeStudio, getDemoPassword(), { pid, name: card.name }, { timeoutMs: SIGN_IN_TIMEOUT_MS }).then((ok) => {
    // The switch itself already happened on screen; say so if the token didn't
    // follow (tv-v28k). Only for the latest sign-in (a failed latest one leaves no
    // token, and none is still in flight) and only if the user is still on it.
    const latestFailed = !ok && getAuthToken() === null && !isSigningIn();
    if (latestFailed && useSessionStore.getState().persona === card.persona) {
      useUIStore.getState().pushNotification({
        intensity: 'high',
        title: `Couldn't sign in as ${card.name}`,
        body: 'The sign-in didn’t go through, so changes may be refused. Switch persona again to retry.',
        ttlMs: 8000,
      });
    }
    return ok;
  });
}
